const WORDS = ["Calm", "Clarity", "Compassion", "Presence", "Safety", "Slow Transformation"];

export const Marquee = () => {
  const line = WORDS.join(" \u00B7 ") + " \u00B7 ";
  return (
    <div className="overflow-hidden border-y border-[#4A6B56]/15 py-6 bg-[#F4F0E8]" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        <span className="font-serif text-2xl sm:text-3xl text-[#4A6B56]/70 mr-8">{line.repeat(3)}</span>
        <span className="font-serif text-2xl sm:text-3xl text-[#4A6B56]/70 mr-8">{line.repeat(3)}</span>
      </div>
    </div>
  );
};
